// src/pages/Home.js
import Navbar from "../components/Navbar";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import ServiceDetailsSection from "../components/ServiceDetailsSection";

import PracticeAreasSection from "../components/PracticeAreasSection";
import TeamSection from "../components/TeamSection";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";
import TestimonialsSection from "../components/TestimonialsSection";
import StatsSection from "../components/StatsSection";


function Home() {
  return (
    <div className="bg-white text-deepgreen min-h-screen">
      <Navbar />

      {/* Hero Banner Section */}
      <div className="relative w-full h-screen bg-black overflow-hidden">
        <img
          src="/loj-banner.png"
          alt="Lady Justice Banner"
          className="absolute inset-0 w-full h-full object-cover brightness-[0.4]"
        />
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full px-6">
          <h1 className="text-gold text-4xl md:text-6xl font-extrabold font-serif leading-tight mb-6 animate-fadeUp">
            Legal Excellence.<br />Personal Commitment.
          </h1>
          <p className="text-white text-lg md:text-xl max-w-2xl mb-8 animate-fadeUp delay-100">
            At Elvis Nanda, Weke & Co. Advocates, we deliver trusted counsel and strategic results for individuals and businesses.
          </p>
          <a
            href="#contact"
            className="bg-gold text-deepgreen font-bold py-3 px-6 rounded-lg hover:bg-white hover:text-deepgreen transition animate-fadeUp delay-200"
          >
            Book a Consultation
          </a>
        </div>
      </div>

      {/* Content Sections */}
      <StatsSection />
      <AboutSection />
      <ServicesSection />
      <ServiceDetailsSection />
      <PracticeAreasSection />
      <TeamSection />
      <TestimonialsSection />
      <ContactCTA />
      <Footer />
    </div>
  );
}

export default Home;
